"use client";

import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

type Props = {
  left: string;
  right: string;
  status: boolean;
  onStatusSwitch: (value: boolean) => void;
};

const BlessSwitch = ({ left, right, status, onStatusSwitch }: Props) => {
  return (
    <div className={styles.switchContainer}>
      <button
        aria-pressed={!status}
        className={classNames(styles.button, status == false && styles.active)}
        onClick={() => onStatusSwitch(false)}>
        {left}
      </button>
      <button
        aria-pressed={!status}
        className={classNames(styles.button, status === true && styles.active)}
        onClick={() => onStatusSwitch(true)}>
        {right}
      </button>
    </div>
  );
};

export default BlessSwitch;
